import { createContext } from 'react';

export const AppContext = createContext();
export const BuilderContext = createContext();
export const TourContext = createContext();
